<template>
	<ActivityLayout class="goal-start-date-activity">
		<template #badge>
			<DateChangeActivityBadge />
		</template>
		<template #text>
			<p>{{ translate( "text", {
				changedBy: activity.changedBy,
				from: activity.from,
				to: activity.to
			} ) }}</p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
	</ActivityLayout>
</template>

<script>
import ActivityLayout from "../Activity/ActivityLayout.vue";
import DateChangeActivityBadge from "../Activity/DateChangeActivityBadge.vue";

export default {
	name: "GoalStartDateActivity",
	components: {
		ActivityLayout,
		DateChangeActivityBadge,
	},
	props: {
		/** { changedBy:String, changedAt:String, to:String, from:String } */
		activity: {
			type: Object,
			required: true,
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.GoalStartDateActivity.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
